import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import classnames from 'classnames';
import { Columns3, Filter, Plus } from 'lucide-react';

import { Input } from 'reactstrap';
import { CardHeader, CardBody } from 'src/componentes/card';

import FiltroChip from 'src/componentes/filtro-chip';
import Button from 'src/componentes/button';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import ContentManager from 'src/componentes/content-manager';
import Filtro from 'src/componentes/filtro';
import ColunasTabelas from 'src/componentes/list/componentes/colunas-tabela';
import Email from '../email';
import FiltroDrawerNew from 'src/componentes/filtro/FiltroDrawerNew';

function ListToolbar({
  intl,
  showSearch,
  showFastSearch = true,
  showExport,
  searchText,
  searchSchema,
  searchComponent,
  onSearchChange,
  onColumnsChange,
  onRefresh,
  onExport,
  allColumns,
  columns,
  columnsTag,
  filterTag,
  filter,
  setOpenFilter,
  useSavedFilter,
  actions,
  permissions,
  handleNewClick,
  showNew,
  refreshFilterChip,
  exportActions,
  sortField,
  renderNewButton,
  onChangeUrl,
  showExportEmail,
  urlExportEmail,
  dateFilterFormat,
  actionsLocal,
  customButtons,
  parameters,
  filterDrawer = false,
  modelValue,
  showModal = false,
  tipoItem,
  tipoItensCamposCustomizados,
  search,
  url,
  onRemoveFilterChip = () => {}, // Função para chamar após remover o filtro chip
  forceShowSearch = false, //Exibir filtro chip e filtro mesmo sem filtroTag
  handleIsValidDragToUsedColumns,
  ehEstatistica = false,
  isLoading = false,
  refreshData,
  enableSearch = false,
  ...rest
}) {
  const [searchValue, setSearchValue] = useState(searchText);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isDrawerMounted, setIsDrawerMounted] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const handleSearchChange = (e) => {
    clearTimeout(searchTimeout);

    const value = e.target.value;
    setSearchValue(value);

    setSearchTimeout(
      setTimeout(() => {
        onSearchChange && onSearchChange(value);
      }, 1000)
    );
  };

  const handleOpenDrawer = () => {
    setIsDrawerMounted(true);
    setTimeout(() => {
      setShowFilterDrawer(true);
    }, 10);
  };

  const handleSearchClick = () => {
    if (filterDrawer) {
      handleOpenDrawer();
      return;
    }

    if (setOpenFilter) setOpenFilter(true);
    else {
      let customFilter = filter;
      if (!customFilter) customFilter = undefined;

      ContentManager.addContent(
        <Filtro
          {...rest}
          modelValue={modelValue}
          filtroId={filterTag}
          searchComponent={searchComponent}
          searchSchema={searchSchema}
          selectedFilter={customFilter}
          usarFiltroSalvo={useSavedFilter}
          onSearch={(filter) => onRefresh && onRefresh(filter)}
        />
      );
    }
  };

  const handleNewClickButton = () => {
    handleNewClick(onRefresh, refreshData);
  };

  const handlePDFClick = () => {
    if (onExport) onExport('pdf');
  };

  const handleExcelClick = () => {
    if (onExport) onExport('xlsx');
  };

  const handleEmailClick = () => {
    (urlExportEmail || url) &&
      ContentManager.addContent(
        <Email
          model={url ? filter?.valor : { filtro: filter ? filter : null }}
          urlExport={urlExportEmail}
          parameters={parameters}
          url={url}
        />
      );
  };

  const handleConfigColumns = () => {
    ContentManager.addContent(
      <ColunasTabelas
        columns={columns}
        allColumns={allColumns}
        tag={columnsTag}
        handleAtualizarColunas={() => onColumnsChange && onColumnsChange()}
        isValidDragToUsedColumns={handleIsValidDragToUsedColumns}
      />
    );
  };

  const handleCloseDrawer = () => {
    setShowFilterDrawer(false);

    setTimeout(() => {
      setIsDrawerMounted(false);
    }, 300);
  };

  return (
    <>
      <CardHeader>
        <div className="align-items-center d-flex justify-content-between">
          {showSearch && showFastSearch ? (
            <div
              style={{ width: 187, minWidth: 187 }}
              className="d-inline-flex"
            >
              <Input
                className="mr-2"
                placeholder={intl.formatMessage({ id: 'label.pesquisaRapida' })}
                autoFocus
                value={searchValue}
                onChange={handleSearchChange}
                type="text"
                disabled={isLoading}
              />
            </div>
          ) : (
            <div></div>
          )}
          {(showSearch || forceShowSearch) && (
            <div style={{ minWidth: 40 }} className="mr-auto">
              <FiltroChip
                updateProps
                filtroId={filterTag}
                onSearch={(newFilter) => onRefresh && onRefresh(newFilter)}
                searchSchema={searchSchema}
                selectedFilter={
                  filter && filter.valor != null ? filter.valor : filter
                }
                currentFilter={filter}
                refreshFilterChip={++refreshFilterChip}
                onChangeUrl={onChangeUrl}
                dateFormat={dateFilterFormat}
                onRemoveFilterChip={onRemoveFilterChip}
              />
            </div>
          )}
          <div
            className={classnames(
              filterTag && showSearch
                ? 'justify-content-end'
                : 'justify-content-start',
              'd-flex'
            )}
          >
            {customButtons && customButtons()}
            {showSearch && (filterTag || forceShowSearch) && (
              <Button
                className="tw:ms-2"
                toolbar
                icon={<Filter strokeWidth={1.75} />}
                onClick={() => handleSearchClick()}
              />
            )}
            {showExport && (
              <UncontrolledDropdown
                group
                direction="left"
                className="ml-2"
                key="list"
              >
                <DropdownToggle
                  toolbar
                  icon="Ellipsis"
                  className={ehEstatistica ? 'estatisticas-step3' : undefined}
                />
                <DropdownMenu>
                  {actionsLocal &&
                    actionsLocal.map((a, index) =>
                      React.cloneElement(a, {
                        key: index + 4,
                      })
                    )}
                  {showExportEmail && (
                    <DropdownItem onClick={handleEmailClick}>
                      <FormattedMessage id="enviarEmail" />
                    </DropdownItem>
                  )}
                  <DropdownItem onClick={handlePDFClick}>
                    <FormattedMessage id="label.exportarPDF" />
                  </DropdownItem>
                  <DropdownItem onClick={handleExcelClick}>
                    <FormattedMessage id="label.exportarExcel" />
                  </DropdownItem>
                  {exportActions
                    ? exportActions(filter, searchValue, sortField)
                    : ''}
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
            {columnsTag && (
              <Button
                className="tw:ms-2"
                color="secondary"
                toolbar
                icon={Columns3}
                onClick={handleConfigColumns}
              />
            )}
            {showNew &&
              permissions &&
              permissions.allowCreate &&
              (renderNewButton ? (
                renderNewButton()
              ) : (
                <Button
                  className="tw:ms-2"
                  toolbar
                  icon={Plus}
                  onClick={() => handleNewClickButton()}
                />
              ))}
            {actions &&
              actions.length > 0 &&
              actions.map((a, index) =>
                React.cloneElement(a, {
                  key: index,
                })
              )}
          </div>
        </div>
      </CardHeader>
      <CardBody className="p-0 m-0">
        {filterDrawer && isDrawerMounted && (
          <FiltroDrawerNew
            onChangeUrl={onChangeUrl}
            modelValue={modelValue}
            filtroId={filterTag}
            usarFiltroSalvo={useSavedFilter}
            searchComponent={searchComponent}
            searchSchema={searchSchema}
            onSearch={(filter) => onRefresh && onRefresh(filter)}
            showModal={showModal}
            url={url}
            selectedFilter={filter}
            search={search}
            tipoItem={tipoItem}
            tipoItensCamposCustomizados={tipoItensCamposCustomizados}
            tipoLayout="drawer"
            isOpen={showFilterDrawer}
            handleClose={handleCloseDrawer}
            enableSearch={enableSearch}
          />
        )}
      </CardBody>
    </>
  );
}

export default injectIntl(ListToolbar);
